// src/firebase.js
// ✅ FIXED VERSION - Copy this entire file

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "asia-south1"); // ✅ Specify region
// v2.3.4: bucket comes from env (was hardcoded to the DEV bucket)
const storage = getStorage(app, `gs://${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}`);

// ✅ Export functions directly (don't export httpsCallable here)
export { auth, db, functions, storage };